import { sendGoogleEvent } from '@html/_common/utils';

const EVENT_CATEGORY = '24/7 customer support';

export default function AOClpContactUs() {
  const openAskAQuestion = () => {
    import(/* webpackChunkName: "AskAQuestion" */'@html/_common/question/script').then((module) => {
      const AskAQuestion = module.default;
      const question = new AskAQuestion();
      question.startEnquiryDialog({
        id: -1,
        name: `CLP - ${window.location.pathname.substring(1)}`,
        forceEnqiry: true,
      });
    });
  };

  const onClickContactUs = () => {
    openAskAQuestion();

    sendGoogleEvent(
      'Ask A Question',
      'Ask a question open',
      `CLP - ${window.location.pathname.substring(1)}`,
      {
        ampEventName: 'ask_question_form_opened',
      },
    );
  };

  const linkClickEvent = () => {
    $('.js-ao-clp-contact-us__cta').on('click', (event) => {
      event.preventDefault();
      const $clickedElement = $(event.currentTarget);
      const clickedElementLink = $clickedElement.attr('href');

      if (typeof clickedElementLink === typeof undefined || clickedElementLink === false) {
        return;
      }

      sendGoogleEvent(EVENT_CATEGORY, clickedElementLink);

      onClickContactUs();
    });
  };

  return { initiate: linkClickEvent };
}
